'use strict';

export default function routes($stateProvider) {
    'ngInject';

    $stateProvider.state('main.yearly_demand_report', {
        template: '<yearly-demand-report></yearly-demand-report>'
    });
}



// WEBPACK FOOTER //
// ./public/dev/app/demand_report/yearly/yearly_demand_report.routes.js